export default import.meta.ROLLUP_FILE_URL_eXntjQfP$tLNjMF8CEy37A;